<template>
  <div>
    <!-- 列表页面 -->
    <div class="container">
      <!-- 列表页面 -->
      <div style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
        <i class="el-icon-s-fold" ></i>
        <el-breadcrumb separator="/" >
          <el-breadcrumb-item >内容管理</el-breadcrumb-item>
          <el-breadcrumb-item >分组管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

        <div class="table-content">
          <div class="header-common">
            <div class="header-common-left">
              <div class="title">分组列表信息</div>
            </div>
            <!-- <header class="header-common-right" v-if="showActionAdd==true">
              <router-link class="right-button-base" :to="{path:'/manage/group/group-add'}">
                新增分组
              </router-link>
            </header> -->
          </div>
          <div class="table-list">
            <el-table
              v-loading='loading'
              border
              style="width: 100%;"
              :cell-style="tableCellStyle"
              :header-cell-style="tableHeaderCellStyle"
              :max-height="tableHeight"
              :data="tableData"
              >
              <!-- :data="tableData.filter(data => !search || data.createDate.toLowerCase().includes(search.toLowerCase()) || data.authorName.toLowerCase().includes(search.toLowerCase()) || data.typeText.toLowerCase().includes(search.toLowerCase()) || data.filename.toLowerCase().includes(search.toLowerCase()) || data.url.toLowerCase().includes(search.toLowerCase()))" -->

              <el-table-column
                 type="index"
                 label="序号">
               </el-table-column>
              <el-table-column
                prop="name"
                label="名称">
              </el-table-column>
              <el-table-column
                prop="description"
                label="描述">
              </el-table-column>
              <el-table-column
                prop="permissions"
                label="权限">
                <template slot-scope="scope">
                  <div v-for="(item,index) in scope.row.permissions">
                    <span style="float: left;margin: 5px 15px;color: #fff;background-color: #104C90;padding: 2px 6px;border-radius: 5px;">{{item.name}}</span>
                  </div>
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="操作">
                <template slot-scope="scope">
                    <router-link
                    v-if="scope.row.userDefined==true&&showActionAdd==true"
                    class="action-button-base"
                    :to="{path: '/manage/group/group-edit',query:{'code': scope.row.code}}"
                    >
                      修改
                    </router-link>
                    <el-button
                      @click.native.prevent="deleteGroup(scope.$index,scope.row)"
                      type="text"
                      size="small"
                      style="background-color: #20478D;"
                      v-if="scope.row.userDefined==true&&showActionDelete==true"
                      class="action-button">
                      删除
                    </el-button>
                    <el-button
                      type="text"
                      size="small"
                      style="background-color: #787268"
                      v-if="scope.row.userDefined!==true"
                      class="action-button-unabled"
                      @click="showForbid"
                    >
                      禁止修改
                    </el-button>
                </template>
              </el-table-column> -->
            </el-table>
          </div>

        </div>
    </div>
  </div>
</template>

<script>
  // import { permissionCheckUtil } from '../../../utils/permission.js'

  export default {
    data() {
      return {
        search:'',
        tableHeight:0,
        tableData:[],//账号列表信息数据
        loading:false,

        // showActionAdd:false,
        // showActionDelete:false
      }
    },
    methods:{
      tableCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);text-align:center;font-size: 14px;font-weight: 400;color: #FEFEFE;margin-right:5px;'
      },
      tableHeaderCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);background:#021950;text-align:center;font-size: 15px;font-weight: 400;color: #00FFFF;margin-right:5px;'
      },
      getGroupList(){
        this.loading = true;
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/accountgroup/list';

        this.$http({
          method:'GET',
          url:url,
          headers:headers
        }).then(res=>{
          this.loading = false;
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.groups){
                this.tableData = obj.data.groups;
              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          this.loading = false;
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      showForbid(){
        this.$message({
          message:'固定分组,不能修改相关权限',
          type:'warning'
        })
      },
      deleteGroup(index,row){
        this.$confirm('此操作将永久删除该文件，是否继续？','提示',{
          confirmButtonText:'确定',
          cancelButtonText:'取消',
          type:'warning'
        }).then(() => {
          this.deleteRowAction(index,row.code);
        }).catch(() => {
          this.$message({
            type:'info',
            message:'取消操作'
          })
        })
      },

      deleteRowAction(index,code){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/accountgroup/delete';
        var data = {'code':code}
        this.$http({
          method:'POST',
          url:url,
          headers:headers,
          data:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              this.tableData.splice(index,1);
              this.$message({
                type:'success',
                message:'删除成功'
              })
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      // judgePermissions(){
      //     let group1 = permissionCheckUtil.findName("accountgroup:create")
      //     let group2 = permissionCheckUtil.findName("accountgroup:delete")

      //     if(group1==true){
      //       this.showActionAdd = true;
      //     }
      //     if(group2==true){
      //       this.showActionDelete = true;
      //     }
      // }
      sizeFun(){
        this.$nextTick(() => {
          this.tableHeight = window.innerHeight-210 < 300 ? 300 : window.innerHeight - 210;
        })
      }
    },
    mounted() {
      window.addEventListener('resize',this.sizeFun)
      this.sizeFun()
      this.getGroupList();
      // this.judgePermissions()
    },
    created() {
      
    },
    beforeDestroy() {
      window.removeEventListener('resize',this.sizeFun)
    }
  }

</script>


<style lang="scss" scoped>
.container {
  margin-top: $header-height;

  .table-content{

    .header-common{
      width: 100%;
      height: 45px;
      border-radius: 12px 12px 0 0 ;
      background: linear-gradient(-90deg, #001940, #1564BE);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-right: 10px;

      .header-common-left{

        font-size: 20px;

        font-weight: bold;
        color: #FEFEFE;
        margin-left: 21px;

        .title{
          font-size: 20px;
          font-weight: bold;
          color: #FEFEFE;
        }
      }

      .header-common-right{

        .right-button{
          width: 100px;
          height: 40px;
          // line-height: 55px;
          background: #FAFAFA;
          border: 1px solid rgba(0,255,96,0.84);
          border-radius: 20px;
          font-size: 14px;

          font-weight: 400;
          color: #00FFB4;
          margin-right: 20px;
        }

        .right-button-base{
          width: 89px;
          height: 40px;
          border: 1px solid rgba(0,144,255,0.84);
          border-radius: 20px;
          background-color: #20478D;
          font-size: 14px;
          font-weight: 400;
          color: #00DEFF;
          margin-right: 20px;
          display: inline-block;
          line-height: 40px;
          text-align: center;
          text-decoration: none;
        }
      }
    }

    .table-list{

      .hander{
        cursor: pointer;
        color: #fff;
        background-color: #104C90;
        border: 0px;
      }

      .action-button{
        width: 89px;
        height: 31px;

        border: 1px solid rgba(0,144,255,0.84);
        border-radius: 18px;
        font-size: 14px;

        font-weight: 400;
        color: #00DEFF;
      }
      .action-button-unabled{
        width: 89px;
        height: 31px;

        border: 1px solid #A0A0A0;
        border-radius: 18px;
        font-size: 14px;

        font-weight: 400;
        color: #fff;
      }

      .action-button-base{

        display: inline-block;
        width: 89px;
        height: 31px;
        line-height: 31px;
        border: 1px solid rgba(0,144,255,0.84);
        border-radius: 18px;
        color: #00DEFF;
        text-align: center;
        text-decoration: none;
        font-size: 14px;
        font-weight: 400;
      }

    }

  }


}
</style>



// WEBPACK FOOTER //
// src/view/manage/group/group-list.vue